import TwoFactorBackupCodes from './TwoFactorBackupCodes';

export default TwoFactorBackupCodes;
